/**
 * Section: Article slider
 * ------------------------------------------------------------------------------
 * This builder all the resonsive carousels on the article page.
 *
 * @namespace article
 */

import Swiper from 'swiper/bundle';

/**
 * Export default article slider
 */

export default () => {
  const slider = document.querySelectorAll('.article__slider');

  function createSliders(target) {
    const slideNumber = target.dataset.swiperSlides;
    const controls = target.dataset.swiperControls;

    const swiper = new Swiper(target, {
      slidesPerView: slideNumber,
      loop: false,
      spaceBetween: 0,
      centeredSlides: false,
      navigation: {
        nextEl: `.swiper-button-next--${controls}`,
        prevEl: `.swiper-button-prev--${controls}`,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: 'true',
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          centeredSlidesBounds: true,
        },
        767: {
          slidesPerView: 2,
        },
        1023: {
          slidesPerView: 2,
        },
        1180: {
          slidesPerView: 2,
        },
        1220: {
          slidesPerView: 3,
        },
        1220: {
          slidesPerView: slideNumber,
        },
      },
    });
    swiper.on('slideChange', () => {
      // console.log("slide changed");
      // console.log(target.replace('#', ''));
      window._wq = window._wq || [];
      _wq.push({
        id: '_all',
        onReady(video) {
          // console.log("Stop video");
          video.pause();
        },
      });
    });
  }

  function checkSliderNav(item) {
    const slides = item.querySelectorAll('.swiper-slide').length;
    const slideNumber = item.dataset.swiperSlides;
    const controls = item.dataset.swiperControls;

    // console.log(`${controls} - ${slideNumber} - ${slides}`);

    // item.classList.toggle("no-arrows-no-dots", slides == slideNumber);

    if (slides <= slideNumber) {
      item.className += ' no-dots-no-arrows';
    }
  }

  function init() {
    slider.forEach((item) => {
      createSliders(item);
      checkSliderNav(item);
    });
  }

  /**
   * Return immutable object.
   */
  return Object.freeze({
    init,
  });
};
